export const SET_ONLINE = (state, payload) => {
  state.isOnline = !!payload
}

// SET_INSTANCE_ID
export const SET_INSTANCE_ID = (state, { id }) => {
  state.instanceId = id
}
